import { QuickbooksUpdateStatusEnum } from './QuickbooksUpdateStatusEnum'
import { QuickbooksUpdateTypeEnum, QuickbooksUpdateTypeTranslation } from './QuickbooksUpdateTypeEnum'
import { Entity, field, rootCollection } from 'firebase-firestorm/lib'

@rootCollection({ name: 'quickbooksUpdate' })
export class QuickbooksUpdate extends Entity {
  @field({ name: 'id' })
  id!: string

  @field({ name: 'restaurantId' })
  restaurantId!: string

  @field({ name: 'type' })
  type!: QuickbooksUpdateTypeEnum

  get typeName() {
    return QuickbooksUpdateTypeTranslation[this.type]
  }

  @field({ name: 'typeId' })
  typeId!: string

  @field({ name: 'exportId' })
  exportId!: string

  @field({ name: 'glCode' })
  glCode!: string

  @field({ name: 'summary' })
  summary!: string

  @field({ name: 'status' })
  status!: QuickbooksUpdateStatusEnum

  @field({ name: 'meta' })
  meta!: { [key: string]: any }

  @field({ name: 'error' })
  error!: string

  @field({ name: 'createdAt' })
  createdAt!: Date

  get createdAtDate() {
    if (!( this.createdAt instanceof Date )) {
      // @ts-ignore
      return this.createdAt.toDate()
    }

    return this.createdAt
  }

  @field({ name: 'sentAt' })
  sentAt!: Date

  get sentAtDate() {
    if (!( this.sentAt instanceof Date )) {
      // @ts-ignore
      return this.sentAt.toDate()
    }

    return this.sentAt
  }
}
